"use strict";
export var UniversalImageResizeMode = /* @__PURE__ */ ((UniversalImageResizeMode2) => {
  UniversalImageResizeMode2["Center"] = "center";
  UniversalImageResizeMode2["Contain"] = "contain";
  UniversalImageResizeMode2["Cover"] = "cover";
  UniversalImageResizeMode2["Stretch"] = "stretch";
  return UniversalImageResizeMode2;
})(UniversalImageResizeMode || {});
